
export default {
  name: 'ObfuscateTooltip',
  props: {
    condition: {
      type: Boolean,
      default: true
    },
    cleartext: {
      type: String,
      required: true
    },
    info: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ' ... '
    },
    prefix: {
      type: String,
      default: ''
    },
    suffix: {
      type: String,
      default: ''
    },
    clazz: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activator: null
    }
  },
  computed: {
    maxWidthTooltip () {
      if (this.$vuetify.breakpoint.mobile) {
        return '80vw'
      } else {
        return '40vw'
      }
    }
  },
  mounted () {
    this.activator = this.$refs.activator
  }
}
